module.exports = __webpack_public_path__ + "img/service_view_requests.bd0b99eb.svg";